// colors
import { Action } from "../colors";

export const MuiDialogComponent = {
    styleOverrides: {
        root: {
            ".MuiPaper-root": {
                maxWidth: "none",
                borderRadius: "10px",
                overflow: "hidden",
            },

            ".MuiDialogTitle-root": {
                backgroundColor: Action.background[70],
            },
        },
    },
};
